import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import { getGlobalMobileClasses } from '../../../themes';
import AuthUserContainer from '../../../containers/AuthUser';
import timeClockColoredIcon from '../../../images/icons/timeClockColored.svg';
import MobileHeader from '../common/MobileHeader';

//const stlBlue = '#1289d4';
const styles = (theme) => {
	return {
		...getGlobalMobileClasses(theme),
		welcomeContainer: {
			display: 'flex',
			alignItems: 'center',
			marginTop: '2vw',
			paddingBottom: '3vw',
			textAlign: 'center',
		},
		welcomeText: {
			textTransform: 'uppercase',
			fontFamily: "'Roboto Condensed', sans-serif",
			fontSize: '220%',
			color: '#333',
			marginLeft: 5,
			textAlign: 'center',
			width: '100%',
			fontWeight: '900',
		},
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: '175%',
			borderBottom: '1px solid #ddd',
			paddingBottom: 15,
			marginBottom: 15,
		},
		loginWarning: {
			margin: '2vw 0',
			padding: '4vw',
			borderRadius: '1vw',
			border: '1px solid #eee',
			borderBottom: '1px solid #ddd',
			fontSize: '130%',
			backgroundColor: '#0c5d90',
			color: 'white',
			lineHeight: '1.4',
		},
		boldName: {
			fontSize: '100%',
			fontWeight: 800,
			display: 'inline-block',
			borderBottom: '2px solid #E9791E',
			margin: `0px 1vw`,
			paddingBottom: '0vw',
		},
		timeClockContainer: {
			margin: '3vw 0',
			padding: '4vw',
			borderRadius: '1vw',
			border: '1px solid #eee',
			borderBottom: '1px solid #ddd',
			backgroundColor: '#fff',
		},
	};
};

class MobilePleaseClockIn extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'clockInDateTime',
			lastPunchInfoResults: undefined,
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
			recentTimeClockShifts: undefined,
		};
	}

	componentDidMount() {}

	render() {
		const { authUser } = this.props;

		let innerRender =
			authUser?.role === 'driver' || authUser?.userId === 1
				? this.renderDriverDashboard
				: this.renderNonDriverDashboard;

		return <Fragment>{innerRender()}</Fragment>;
	}

	renderDriverDashboard = () => {
		const { classes, authUser } = this.props;
		return (
			<div>
				<MobileHeader showLogo={true} />
				<div
					className={classes.globalContent}
					style={{ padding: '3vw', backgroundColor: '#f6f6f7' }}
				>
					<div className={classes.welcomeContainer}>
						<div className={classes.welcomeText}>Welcome! Please Clock In!</div>
					</div>

					<div className={classes.loginWarning}>
						If you are not
						<span className={classes.boldName}>
							{' '}
							{authUser.firstName} {authUser.lastName}{' '}
						</span>
						please log out and log back in under your account to get your clock in status.
					</div>
					<div style={{ display: 'flex' }} className={classes.timeClockContainer}>
						<img
							alt="ticket"
							src={timeClockColoredIcon}
							style={{ width: '10vw', paddingRight: '1vw' }}
						/>
						<div style={{ fontSize: '140%' }}>
							To use Sphere Mobile you must first clock in at a designated terminal. After that you
							can refresh this screen and you will be all set.
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderNonDriverDashboard = () => {
		const { classes } = this.props;
		return <div className={classes.contentTitle}>Sphere mobile for the drivers only</div>;
	};
}

MobilePleaseClockIn.propTypes = {
	authUser: PropTypes.object,
};
export default _.flow([withStyles(styles), AuthUserContainer])(MobilePleaseClockIn);
